import React from "react";
import Otp from "../Component/Otp";
import { Box, Toolbar, Typography } from "@mui/material";
import Footer from "../Component/Footer";
import Header from "../Component/header";
import { useLanguage } from '../context/LanguageContext';
import DesktopFooter from "../Component/Desktopfooter";
const Secondscreen = () => {
    const { t } = useLanguage();


    return (
        <>
            <div className='aboutSection'>
<Header/> 
                <Box>
                    <Toolbar>
                        <Otp />
                    </Toolbar>
                </Box>
            </div>
             <DesktopFooter/>
            <Footer />

        </>


    );

}
export default Secondscreen;